// 提示框
import {
  Message
} from "element-ui"

let tipPop = {
  Success(message) {
    Message.success(message)
  },
  warning(message) {
    Message.warning(message)
  },
  info(message) {
    Message.info(message)
  },
  error(message) {
    Message.error(message)
  }
}

export default {
  tipPop
}



// WEBPACK FOOTER //
// ./src/common/commonFn.js